import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { GbgemeindeService, GemeindeSearchRequestMeta } from '../../../core/gb-api';
import { Subscription } from 'rxjs';
import { FormsModule, NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TimepointService } from '../../../core/services/timepoint.service';
import { submit } from '../gemeinde-list/gemeinde.functions';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { SearchStateService } from '../../../shared/services/search-state.service';
import { AbstractSearchComponent } from '../../../shared/components/abstract-component/abstract-search.component';
import { SearchMode } from '../../../shared/enum/searchMode';
import { ContentHeaderComponent } from '../../../shared/components/content-header/content-header.component';
import { TitleComponent } from '../../../shared/components/title/title.component';
import { MetaDirective } from '../../../shared/directives/meta.directive';
import { CapFormRowDirective } from '../../../shared/form-control/cap-form-row.directive';
import { CapFormControlComponent } from '../../../shared/form-control/form-control.component';
import { AutofocusDirective } from '../../../shared/directives/autofocus.directive';
import { MetaDisablerDirective } from '../../../shared/directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../../shared/directives/meta-validator.directive';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-gemeinde-suche',
  templateUrl: './gemeinde-suche.component.html',
  styleUrls: ['./gemeinde-suche.component.scss'],
  imports: [
    ContentHeaderComponent,
    TitleComponent,
    FormsModule,
    MetaDirective,
    CapFormRowDirective,
    CapFormControlComponent,
    AutofocusDirective,
    MetaDisablerDirective,
    MetaValidatorDirective,
    TranslatePipe
  ]
})
export class GemeindeSucheComponent extends AbstractSearchComponent implements OnInit, OnDestroy {
  gemeinde: GemeindeSearchRequestMeta;

  @ViewChild('form', { static: false })
  form: NgForm;

  @ViewChild('gemeinde.name', { static: false })
  nameField: ElementRef;

  private subscription: Subscription;

  constructor(
    private gbGemeindeService: GbgemeindeService,
    private router: Router,
    stateService: SearchStateService,
    private route: ActivatedRoute,
    private timepointService: TimepointService
  ) {
    super(stateService);
    keysToTranslate<string>(['gemeinde.SucheTitel', 'gemeinde.name', 'gemeinde.bfs', 'gemeinde.kreis', 'gemeinde.breadcumbSuche']);
  }

  ngOnInit() {
    this.timepointService.resetTimepoint();
    this.subscription = this.gbGemeindeService.searchGbGemeindeStandardTemplate().subscribe((template) => {
      this.gemeinde = this.copyLastRequest(template);
    });
  }

  onSubmit(): void {
    this.stateService.lastRequest = { ...this.gemeinde };
    if (!this.gemeinde.bfs && !this.gemeinde.kreis && !this.gemeinde.name) {
      this.gemeinde.name = '*';
    }
    submit(this.form, SearchMode.searchStandard, this.gemeinde, this.router, this.route);
  }

  onReset(): void {
    this.form.reset();
    this.subscription = this.gbGemeindeService.searchGbGemeindeStandardTemplate().subscribe((template) => {
      this.gemeinde = template;
      this.nameField.nativeElement.focus();
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
